<script lang="ts">
	import type { SwiperOptions } from 'swiper/types/swiper-options';
	import Slider from './Slider.svelte';
	import { onMount } from 'svelte';
	import Swiper from 'swiper';
	import { page } from '$app/stores';
	import Section from '../layout/Section.svelte';

	/** Important: must be of rem size unit */
	export let offsetVariable = 'page-padding';
	export let options: SwiperOptions = {};
	/*
	export let slidesPerViewPhone;
	export let slidesPerViewTablet;
	export let slidesPerViewDesktop;+
	*/

	let remSize =
		typeof document !== 'undefined'
			? parseFloat(getComputedStyle(document.documentElement).fontSize)
			: 16;

	let pagePadding = calculatePagePadding();

	function updatePagePadding() {
		pagePadding = calculatePagePadding();

		if (!swiper) return;

		swiper.params.slidesOffsetBefore = pagePadding;
		swiper.params.slidesOffsetAfter = pagePadding;
		swiper.slideTo(0);
	}

	export let swiper: Swiper | undefined;

	function calculatePagePadding() {
		return typeof document !== 'undefined'
			? parseFloat(
					getComputedStyle(document.documentElement)
						.getPropertyValue(`--${offsetVariable}`)
						.replace('rem', '')
			  ) * remSize
			: 0;
	}

	$: swiper?.on('slideChange', () => {
	});

	$: swiperOptions = {
		slidesOffsetBefore: pagePadding ?? 100,
		slidesOffsetAfter: pagePadding ?? 100,
		...options
	} as SwiperOptions;
</script>

<svelte:window on:resize={updatePagePadding} />

<div class="full-width-slider">
	<Slider options={swiperOptions} {...$$restProps} bind:swiper>
		<slot />
	</Slider>
</div>

<style lang="scss">
	.full-width-slider {
		display: flex;
		flex-direction: column;
		align-items: center;
		:global(.navigation) {
			display: flex;
			@media (max-width: 600px) {
				display: none;
			}
		}
	}

	:global(.full-width-slider .swiper) {
		width: 100%;
	}
	:global(.full-width-slider .navigation) {
		padding-inline: v(page-padding);
	}
</style>
